import { createContext, useContext, type ReactNode } from "react";

/** What a thread file's chip shows beyond its name; "filed" turns it green (H3's filing sets it). */
export type ThreadFileState = "filed" | null;

const FileStateContext = createContext<(threadFileId: number) => ThreadFileState>(() => null);

/** Wrap the chat to tell its chips which thread files are filed. */
export function ThreadFileStateProvider({
  state,
  children,
}: {
  state: (threadFileId: number) => ThreadFileState;
  children: ReactNode;
}) {
  return <FileStateContext.Provider value={state}>{children}</FileStateContext.Provider>;
}

/** The nearest provider's state function, so an inner provider can add to an outer one. */
export const useFileStates = () => useContext(FileStateContext);

export function useThreadFileState(threadFileId: number | null): ThreadFileState {
  const state = useFileStates();
  return threadFileId == null ? null : state(threadFileId);
}
